import { create } from "zustand";

type SidebarStateStore = {
  sidebarCollapsed: boolean;
  mobileDrawerOpen: boolean;
  setSidebarCollapsed(sidebarCollapsed: boolean): void;
  setMobileDrawerOpen(mobileDrawerOpen: boolean): void;
};

export const useSidebarStateStore = create<SidebarStateStore>((set) => ({
  sidebarCollapsed: false,
  mobileDrawerOpen: false,
  setSidebarCollapsed: (sidebarCollapsed): void =>
    set(() => ({
      sidebarCollapsed,
    })),
  setMobileDrawerOpen: (mobileDrawerOpen): void =>
    set(() => ({
      mobileDrawerOpen,
    })),
}));
